<template>
  <div>
    <md-card-content class="start-inputs signature-inputs">
      <ATSTerms v-bind:infotab="false" />

      <div class="completed-sigs">

        <div class="sigs md-size-50">
          <!--<img src="<%= @ats.customer_signature %>" alt="">-->
          <div class="techinician-block">
            <div class="tech-name">GPR Technician: </div>
            <ValidationProvider name="username" rules="required" v-slot="{ passed, failed }" class="md-layout-item">
              <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                <md-input v-model="request.gpr_techinician" type="text"></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
        </div>

        <div class="sigs md-size-50 company-name">
          <ValidationProvider name="companyname" rules="required" v-slot="{ passed, failed }"
            class="md-layout-item md-size-100">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-input v-model="request.signed_company_name" type="text"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

      </div>


      <div class="sign-box-container">
        <div class="md-layout-item md-size-100">
          <p class="sign-label">Saved Signature</p>
          <img v-bind:src="request.customer_signature" alt="" class="preview-signature">
        </div>
        <p class="sign-label" v-if="!request.customer_signature">Sign to agree to the SafeCore Terms and Conditions</p>
        <SigPad v-on:saveSig="saveSig" v-if="!request.customer_signature" />
      </div>


      <div class="bottom-box">

        <div class="agree-terms">
          <ValidationProvider name="atsterms" rules="required" v-slot="{ passed, failed }"
            class="md-layout-item md-size-100">
            <md-checkbox v-model="request.terms" required :class="[{ 'md-error': failed }, { 'md-valid': passed }]" checked='true'>
              Agree to Terms
            </md-checkbox>
          </ValidationProvider>
        </div>

        <div class="representative">
          <label>Authorized Representative:</label>
          <ValidationProvider name="username" rules="required" v-slot="{ passed, failed }" class="md-layout-item">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-input v-model="request.signed_user_name" type="text"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

      </div>
    </md-card-content>
    <md-card-actions md-alignment="right">
      <md-button class="md-info" v-on:click="goSignature(1)" v-if="goBack">Go Back</md-button>
      <md-button class="md-info" v-on:click="submitSign" :disabled="clickedOnce || !request.terms"
        v-if="!submitLoad">Submit Signature</md-button>
    </md-card-actions>
  </div>
</template>
<script>
import ATSTerms from "@/pages/Dashboard/ProjectPages/Components/ATSTerms.vue";
import SigPad from "@/pages/Dashboard/ProjectPages/Components/SigPad.vue";
import api from "@/api";

export default {
  components: {
    ATSTerms,
    SigPad,
  },
  props: ['request', 'projectId', 'goBack'],
  data() {
    return {
      card3amt: 90,
      notValid: false,
      clickedOnce: false,
      isLoading: false,
      checkForSig: false,
      submitLoad: false
    }
  },
  created() {
    if (this.request.customer_signature) {
      this.submitLoad = true
    }
  },
  methods: {
    goSignature(number) {
      // console.log(this.existingaddress);
      this.$emit("goSign", number);
    },
    prevCard() {
      // console.log(this.existingaddress);
      this.$emit("prev", 3);
    },
    submitSign() {
      this.clickedOnce = true;
      this.isLoading = true;
      api
        .submitJSASign({ customer_signature: this.request.customer_signature, project_id: this.projectId })
        .then((response) => {
          this.notifyVue("Signature has been added", "success");
          // this.$router.push(`/projects/${this.projectId}`);
        });
    },
    async handleSubmit() {
      this.clickedOnce = true;
      this.isLoading = true;
      const isValid = await this.$refs.observer3.validate();
      if (isValid) {
        this.notValid = false;
        this.$emit("submit");
      } else {
        this.isLoading = false;
        this.notValid = true;
        this.clickedOnce = false;
      }
    },
    saveSig(data) {
      this.request.customer_signature = data;
      this.checkForSig = true;
    },
    notifyVue(message, color) {
      // var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        timeout: 2500,
        message: message,
        horizontalAlign: 'left',
        verticalAlign: 'top',
        type: color
      });
    }
  }
}
</script>
<style lang="scss">
.ats-spin {
  margin-right: 10px;
}

.sign-label {
  margin: 0;
  display: inline-block;
  display: block;
  width: 100%;
}

.preview-signature {
  width: 300px !important;
  border: solid 1px #000;
}

@media (min-width: 767px) {
  .completed-sigs {
    display: flex;
    width: 100%;
    margin-top: 10px;
  }

  .completed-sigs .sigs {
    flex: 1 50%;
  }

  .sigpadbox {
    width: 100%;
  }

  .techinician-block {
    display: flex;
  }

  .tech-name {
    margin-top: 10px;
  }

  .techinician-block .md-field {
    margin-top: 5px;
    max-width: 250px;
    margin-left: 20px;
  }

  .techinician-block .md-field .md-input {
    text-align: center;
    height: 28px;
  }

  .company-name .md-field {
    margin-top: 5px;
  }

  .company-name .md-field .md-input {
    text-align: center;
    height: 28px;
  }

  .sign-box-container {
    margin-left: 40%;
    width: 60%;
  }

  .bottom-box {
    display: flex;
    width: 100%;
    margin-top: 30px;
  }

  .bottom-box .agree-terms {
    flex: 1 20%;
  }

  .bottom-box .representative {
    flex: 1 80%;
    display: flex
  }

  .representative .md-field {
    margin-top: 5px;
    margin-left: 20px;
  }

  .representative .md-field .md-input {
    text-align: center;
    height: 28px;
  }

  .representative label {
    margin-top: 15px;
  }
}

@media (max-width: 500px) {
  .start-ats-p {
    font-size: 10px;
  }
}

@media (max-width: 768px) {
  .start-project .md-card .md-card-actions {
    flex-direction: column;
  }
}
</style>
